export default "__VITE_ASSET__Dz5WmayV__"